var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1032 5.18084C12.5482 5.18084 13.7196 4.02107 13.7196 2.59042C13.7196 1.15977 12.5482 0 11.1032 0C9.65814 0 8.48672 1.15977 8.48672 2.59042C8.48672 4.02107 9.65814 5.18084 11.1032 5.18084ZM3.89684 7.43074C5.34186 7.43074 6.51328 6.27097 6.51328 4.84032C6.51328 3.40968 5.34186 2.24991 3.89684 2.24991C2.4518 2.24991 1.28038 3.40968 1.28038 4.84032C1.28038 6.27097 2.4518 7.43074 3.89684 7.43074ZM0 14V11.8583C0 10.1768 1.36733 8.82309 3.06576 8.82309H4.72792C6.42634 8.82309 7.79366 10.1768 7.79366 11.8583V14H0ZM7.58253 8.15293C8.1015 7.21 9.10674 6.5732 10.2719 6.5732H11.9367C13.6351 6.5732 15 7.92416 15 9.60566V11.7493H9.3703V10.906C9.3703 9.67746 8.63819 8.63138 7.58253 8.15293Z",
    fill: "#5571C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.e41cb3dae6b7fdba369a9e586a5c6a05.svg";
export { ForwardRef as ReactComponent };